(function () {
    angular.module('tmx-app')
        .controller('loginCtrl', ['$translate', '$filter', '$scope', '$auth', 'RegistrationUserDataService',
            '$mdDialog', 'ServerExceptionService', '$state', 'CurrentUserService', 'ToastService', 'cacheStore', 'UsersService', 'OtpService', 'EncryptionService', 'TMX_FINANCE_CONSTANTS', 'tmxUtility', '$http', 'APP_CONSTANTS',


            function LoginCtrl($translate, $filter, $scope, $auth, RegistrationUserDataService, $mdDialog,
                ServerExceptionService, $state, CurrentUserService, ToastService, cacheStore, UsersService, OtpService, EncryptionService, TMX_FINANCE_CONSTANTS, tmxUtility, $http, APP_CONSTANTS) {

                var loginCtrl = this;
                var exists;

                exists = tmxUtility.exists;
                var url = APP_CONSTANTS.AuthServer;
                loginCtrl.UserName = 'UserName';
                loginCtrl.Password = 'Password';
                loginCtrl.SignIn = 'SignIn';
                loginCtrl.ConfirmPassword = 'Confirm Password';
                loginCtrl.OldPassword = 'Old Password';
                loginCtrl.ButtonLabel = 'Sign In'
                loginCtrl.isFirstPasswordChange = false;
                loginCtrl.isExpire = false;
                loginCtrl.mainScreenBackgroundUrl = APP_CONSTANTS.mainScreenBackgroundUrl;
                loginCtrl.mainScreenLogoUrl = APP_CONSTANTS.mainScreenLogoUrl || 'assets/images/TmX-DLP-themeGreen.png';
                loginCtrl.languages = [
                    { LookupId: 'en', VisibleValue: 'English', HiddenValue: 'en' },
                    { LookupId: 'ar', VisibleValue: 'Arabic', HiddenValue: 'ar' }
                ];
                loginCtrl.culture = localStorage.getItem('culture');

                // OTP flow control
                loginCtrl.showOtpField = false;
                loginCtrl.loginResponse = null;
                loginCtrl.otpExpired = false;
                loginCtrl.otpTimeout = null;
                loginCtrl.remainingSeconds = 0;
                var otpTimer = null;
                var countdownInterval = null;

                //Encyption Service
                loginCtrl.EncryptionService = EncryptionService;

                //Encryption Key and IV
                var encryptKey = TMX_FINANCE_CONSTANTS.ENCRYPTION_KEY.key;
                var encryptIV = TMX_FINANCE_CONSTANTS.ENCRYPTION_KEY.iv;


                //if(angular.isDefined(ServerExceptionService.Displaymsg)){
                //     
                //    if(ServerExceptionService.Displaymsg != "" && ServerExceptionService.Displaymsg.search("Logged Out") != -1){
                //        //$scope.logout_msg = ServerExceptionService.Displaymsg;
                //        ToastService.showCustomToast("error", ServerExceptionService.Displaymsg);
                //    }
                //};


                //if($scope.watch_count == null || $scope.watch_count == undefined){
                //    //$scope.watch_count = AcrossScreenValidations.setWatch_value(2);
                //}


                ///////////////////CHECK TO SEE IF FIELDS ARE NULL OR PREFILLED///////////////////
                //  if($scope.username != null && $scope.username != undefined)
                //  {
                //      $scope.username = $scope.username;
                //      $scope.password = $scope.password;
                //  }


                ////////////  WATCHING FOR CHANGES IN THE ERROR in  RESPONSE IN LOGIN ///////////////////////////////////////
                $scope.$watch(function () { return ServerExceptionService.Displaymsg }, function (newVal, oldVal) {
                    if ($scope.watch_count > 1) {
                        $scope.logout_msg = "";
                        return;
                    }
                    //if(newVal.$scope.dataLoading == oldVal.$scope.dataLoading){return;}

                    if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {

                        $scope.logout_msg = "";
                        $scope.error = ServerExceptionService.Displaymsg;
                        $scope.dataLoading = false;
                        $scope.watch_count = $scope.watch_count + 1;


                        ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                        // in multiple time using incorrect username and password and the server returns the same error


                        $scope.$on("$destroy", function () {
                            ServerExceptionService.Displaymsg = "";

                        });
                    }

                });
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.termUse = function () {

                    $mdDialog.show({
                        controller: function ($scope, $mdDialog) {
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                        },
                        templateUrl: 'app/public/login/termUse.html',
                        parent: angular.element(document.body),
                        scope: $scope.$new(),
                        clickOutsideToClose: true
                    })
                        .then();
                };
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.policy = function () {

                    $mdDialog.show({
                        controller: function ($scope, $mdDialog) {
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                        },
                        templateUrl: 'app/public/login/policy.html',
                        parent: angular.element(document.body),
                        scope: $scope.$new(),
                        clickOutsideToClose: true
                    })
                        .then();
                };


                $scope.resetpass = function () {

                    var changePassword = {
                        OldPassword: $scope.oldpassword,
                        NewPassword: $scope.password,
                        ConfirmPassword: $scope.confirmpassword
                    };
                    $http.post(url + '/api/account/changepassword', changePassword).success(function (data) {
                        // console.log("Dataaa", data)
                        if (data.status.code == 200) {
                            $scope.error = '';
                            loginCtrl.Password = 'Password';
                            loginCtrl.ButtonLabel = 'Sign In';

                            ToastService.showCustomToast("success", data.status.message);
                            $scope.dataLoading = false
                            loginCtrl.isFirstPasswordChange = false;

                            return;
                        }




                    }).error(function (error) {
                        // console.log("error", error)
                        $scope.dataLoading = false

                    });
                }
                $scope.resetpass2 = function () {


                    var resetPassword = {
                        Email: $scope.username,
                        NewPassword: $scope.password,
                        ConfirmPassword: $scope.confirmpassword
                    };
                    $http.post(url + '/api/account/changeuserpassword', resetPassword).success(function (data) {
                        // console.log("Dataaa", data)
                        if (data.status.code == 200) {
                            loginCtrl.ButtonLabel = 'Sign In';
                            $scope.error = '';
                            loginCtrl.Password = 'Password';
                            ToastService.showCustomToast("success", data.status.message);
                            $scope.dataLoading = false
                            loginCtrl.isExpire = false;

                            return;
                        }




                    }).error(function (error) {
                        // console.log("error", error)
                        $scope.error = error.status.message
                        $scope.dataLoading = false

                    });
                }
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.login = function () {
                    $scope.error = "";
                    $scope.dataLoading = true;
                    $scope.watch_count = 1;

                    var loginEncrypted = false;
                    var loginPassword = $scope.password;
                    var loginUserName = $scope.username;

                    if (loginCtrl.isFirstPasswordChange) {
                        $scope.error = "New User Change your Password"
                        var cpassword = $scope.confirmpassword;
                        var opassword = $scope.oldpassword;
                    }
                    if (exists(APP_CONSTANTS.isEncrypted) && eval(APP_CONSTANTS.isEncrypted)) {
                        loginPassword = loginCtrl.EncryptionService.encrypt($scope.password, encryptKey, encryptIV);
                        loginUserName = loginCtrl.EncryptionService.encrypt($scope.username, encryptKey, encryptIV);
                        loginEncrypted = true;
                    }

                    var authUser = {
                        username: loginUserName,
                        password: loginPassword,
                        isEncrypted: loginEncrypted
                    };

                    if (loginCtrl.isExpire) {
                        var resetPassword = {
                            Email: $scope.username,
                            NewPassword: $scope.password,

                            ConfirmPassword: $scope.confirmpassword
                        };

                        $http.post(url + '/api/account/changeexpiredpassword', resetPassword).success(function (data) {
                            // console.log("Dataaa", data)
                            if (data.status.code == 200) {
                                loginCtrl.ButtonLabel = 'Sign In';

                                ToastService.showCustomToast("success", data.status.message);
                                $scope.dataLoading = false;
                                loginCtrl.isExpire = false;
                                $scope.error = "";

                                return;
                            }
                            return;



                        }).error(function (error) {
                            // console.log("error", error)
                            $scope.dataLoading = false
                        });
                    }

                    loginCtrl.isExpire = false;

                    $auth.login(authUser)
                        .then(function (response) {

                            if (angular.isDefined(response.status) && response.status == "200") {


                                if (response.data.firstPasswordChange == "false") {

                                    $scope.error = 'New User! Change your password'
                                    loginCtrl.Password = 'New Password';
                                    if ($scope.form) {
                                        if ($scope.form.password) {
                                            $scope.password = undefined;
                                            $scope.form.password.$setPristine();
                                            $scope.form.password.$setUntouched();
                                        }
                                        $scope.form.$setPristine();
                                        $scope.form.$setUntouched();
                                    }
                                    if (loginCtrl.isFirstPasswordChange) {
                                        var changePassword = {
                                            OldPassword: opassword,
                                            NewPassword: loginPassword,
                                            ConfirmPassword: cpassword
                                        };


                                        $http.post(url + '/api/account/changepassword', changePassword).success(function (data) {
                                            // console.log("Dataaa", data)
                                            if (data.status.code == 200) {
                                                loginCtrl.ButtonLabel = 'Sign In';

                                                ToastService.showCustomToast("success", data.message);
                                                $scope.dataLoading = false
                                                loginCtrl.isFirstPasswordChange = false;

                                                return;
                                            }




                                        }).error(function (error) {
                                            // console.log("error", error)
                                            $scope.dataLoading = false
                                            loginCtrl.isFirst = false;
                                        });


                                    }
                                    else {
                                        loginCtrl.ButtonLabel = 'Reset Password';
                                        loginCtrl.isFirstPasswordChange = true;
                                        $scope.dataLoading = false;

                                        return;
                                    }
                                }
                                if (response.data.isPasswordExpired == "true") {

                                    loginCtrl.Password = 'New Password';
                                    if ($scope.form) {
                                        if ($scope.form.password) {
                                            $scope.password = undefined;
                                            $scope.form.password.$setPristine();
                                            $scope.form.password.$setUntouched();
                                        }
                                        $scope.form.$setPristine();
                                        $scope.form.$setUntouched();
                                    }
                                    loginCtrl.ButtonLabel = 'Reset Password';
                                    loginCtrl.isExpire = true;
                                    $scope.error = 'Password Expired! Change your password'
                                    $scope.dataLoading = false
                                }
                                else {
                                    loginCtrl.ButtonLabel = 'Sign In';
                                    var loginParams = {
                                        tokenExpiryTime: response.data[".expires"]
                                    }

                                    // Generate OTP
                                    OtpService.GenerateOTPByUserId(response.data.Id).then(function (otpResponse) {

                                        // Check if OTP generation returned 204 - skip OTP flow
                                        if (angular.isDefined(otpResponse.status) && otpResponse.status.code == 204) {
                                            // Skip OTP, proceed directly to MF login
                                            var loginParams = {
                                                tokenExpiryTime: response.data[".expires"]
                                            };
                                            UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                                                if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                                                    if (mfLoginResponse.data.Success == true) {
                                                        postLogin(response);
                                                    }
                                                    else {
                                                        var message;
                                                        switch (mfLoginResponse.status.message) {
                                                            case "11":
                                                                message = $filter('translate')("AlreadyLoggedInConfirmation");
                                                                confirmationDialog(message, function () { forceLogin(response); }, function () { $scope.dataLoading = false; });
                                                                break;
                                                            default:
                                                                message = "Cannot login to server due to unexpected response";
                                                                ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                                                $scope.dataLoading = false;
                                                                break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    $scope.dataLoading = false;
                                                    ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                                }
                                            });
                                        }
                                        else if (angular.isDefined(otpResponse.status) && (otpResponse.status.code == 200 || otpResponse.status.code == 201)) {

                                            loginCtrl.loginResponse = response;

                                            loginCtrl.showOtpField = true;
                                            loginCtrl.otpExpired = false;
                                            $scope.dataLoading = false;

                                            // Get OTP timeout from response or use default (120 seconds = 2 minutes)
                                            var otpTimeout = (otpResponse.data && otpResponse.data.OtpTimeout) ? otpResponse.data.OtpTimeout : 120;
                                            var timeoutInMilliseconds = otpTimeout * 1000; // Convert to milliseconds
                                            loginCtrl.otpTimeout = otpTimeout;
                                            loginCtrl.remainingSeconds = otpTimeout;

                                            // Clear existing timers if any
                                            if (otpTimer) {
                                                clearTimeout(otpTimer);
                                            }
                                            if (countdownInterval) {
                                                clearInterval(countdownInterval);
                                            }

                                            // Start countdown display
                                            countdownInterval = setInterval(function () {
                                                $scope.$apply(function () {
                                                    loginCtrl.remainingSeconds--;
                                                    if (loginCtrl.remainingSeconds <= 0) {
                                                        clearInterval(countdownInterval);
                                                    }
                                                });
                                            }, 1000);

                                            // Set new timer for expiration
                                            otpTimer = setTimeout(function () {
                                                $scope.$apply(function () {
                                                    loginCtrl.otpExpired = true;
                                                    loginCtrl.remainingSeconds = 0;
                                                    if (countdownInterval) {
                                                        clearInterval(countdownInterval);
                                                    }
                                                });
                                            }, timeoutInMilliseconds);
                                        }
                                        else {
                                            $scope.dataLoading = false;
                                            ToastService.showCustomToast("error", otpResponse.status.message || "Failed to generate OTP");
                                        }
                                    })

                                    // UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                                    //     if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                                    //         $scope.dataLoading = false;
                                    //         if (mfLoginResponse.data.Success == true) {
                                    //             postLogin(response);
                                    //         }
                                    //         else {
                                    //             var message;
                                    //             switch (mfLoginResponse.status.message) {
                                    //             case "11":
                                    //                 message = $filter('translate')("AlreadyLoggedInConfirmation");
                                    //                 confirmationDialog(message, function () { forceLogin(response); }, function () { });
                                    //                 break;
                                    //             default:
                                    //                 message = "Cannot login to server due to unexpected response";
                                    //                 ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                    //                 break;
                                    //             }
                                    //             return;
                                    //         }
                                    //     }
                                    //     else {
                                    //         ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                    //     }
                                    // });

                                }

                            }
                            else {
                                $scope.dataLoading = false;
                                ToastService.showCustomToast("error", response.data.status.message);
                            }

                            //if(ENV.backend == 'http://tmxprovisioningapi.azurewebsites.net/api'){
                            //    //$window.open('http://tmxmf.azurewebsites.net/develop/#/home/dashboard', '_self')
                            //
                            //}
                            //else{
                            //    //$window.open('http://172.17.40.106:85/tmxmf/portal/#/home/dashboard', '_self')
                            //    $state.transitionTo('private.dashboard');
                            //}


                        })
                        .catch(function (error) {
                            $scope.dataLoading = false;
                            if (error && error.data && error.data.error_description) {
                                $scope.error = error.data.error_description;
                            }
                        });

                }; //$scope.login function end


                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.verifyOtp = function () {
                    $scope.error = "";
                    $scope.dataLoading = true;

                    var response = loginCtrl.loginResponse;
                    var otp = $scope.otp;

                    if (!otp) {
                        $scope.error = "Please enter OTP";
                        $scope.dataLoading = false;
                        return;
                    }

                    // Verify OTP
                    OtpService.VerifyOTPByUserId(response.data.Id, otp).then(function (otpResponse) {
                        if (angular.isDefined(otpResponse.status) && otpResponse.status.code == 200) {
                            // OTP is valid, proceed with MF login
                            var loginParams = {
                                tokenExpiryTime: response.data[".expires"]
                            };
                            UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                                if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                                    if (mfLoginResponse.data.Success == true) {
                                        postLogin(response);
                                    }
                                    else {
                                        var message;
                                        switch (mfLoginResponse.status.message) {
                                            case "11":
                                                message = $filter('translate')("AlreadyLoggedInConfirmation");
                                                confirmationDialog(message, function () { forceLogin(response); }, function () { $scope.dataLoading = false; });
                                                break;
                                            default:
                                                message = "Cannot login to server due to unexpected response";
                                                ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                                $scope.dataLoading = false;
                                                break;
                                        }
                                        return;
                                    }
                                }
                                else {
                                    $scope.dataLoading = false;
                                    ToastService.showCustomToast("error", mfLoginResponse.status.message);
                                }
                            });
                        }
                        else {
                            $scope.dataLoading = false;
                            $scope.error = otpResponse.status.message || "OTP verification failed";
                        }
                    }).catch(function (error) {
                        $scope.dataLoading = false;
                        loginCtrl.otpExpired = true;
                        $scope.error = "Error verifying OTP";
                    });
                };

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                $scope.resendOtp = function () {
                    $scope.error = "";
                    $scope.dataLoading = true;
                    loginCtrl.otpExpired = false;

                    var response = loginCtrl.loginResponse;

                    if (!response || !response.data || !response.data.Id) {
                        $scope.error = "Session expired. Please login again.";
                        $scope.dataLoading = false;
                        return;
                    }

                    // Generate new OTP
                    OtpService.GenerateOTPByUserId(response.data.Id).then(function (otpResponse) {
                        if (angular.isDefined(otpResponse.status) && (otpResponse.status.code == 200 || otpResponse.status.code == 201)) {
                            loginCtrl.otpExpired = false;
                            $scope.otp = ""; // Clear previous OTP
                            $scope.dataLoading = false;
                            ToastService.showCustomToast("success", "OTP has been resent successfully");

                            // Get OTP timeout from response or use default (120 seconds = 2 minutes)
                            var otpTimeout = (otpResponse.data && otpResponse.data.OtpTimeout) ? otpResponse.data.OtpTimeout : 120;
                            var timeoutInMilliseconds = otpTimeout * 1000;
                            loginCtrl.otpTimeout = otpTimeout;
                            loginCtrl.remainingSeconds = otpTimeout;

                            // Clear existing timers if any
                            if (otpTimer) {
                                clearTimeout(otpTimer);
                            }
                            if (countdownInterval) {
                                clearInterval(countdownInterval);
                            }

                            // Start countdown display
                            countdownInterval = setInterval(function () {
                                $scope.$apply(function () {
                                    loginCtrl.remainingSeconds--;
                                    if (loginCtrl.remainingSeconds <= 0) {
                                        clearInterval(countdownInterval);
                                    }
                                });
                            }, 1000);

                            // Set new timer for expiration
                            otpTimer = setTimeout(function () {
                                $scope.$apply(function () {
                                    loginCtrl.otpExpired = true;
                                    loginCtrl.remainingSeconds = 0;
                                    if (countdownInterval) {
                                        clearInterval(countdownInterval);
                                    }
                                });
                            }, timeoutInMilliseconds);
                        } else {
                            $scope.dataLoading = false;
                            $scope.error = otpResponse.status.message || "Failed to resend OTP";
                        }
                    }).catch(function (error) {
                        $scope.dataLoading = false;
                        $scope.error = "Error resending OTP";
                    });
                };

                function forceLogin(response) {
                    $scope.dataLoading = true;
                    var loginParams = { EndPreviousSession: true, tokenExpiryTime: response.data[".expires"] };
                    UsersService.loginToMF(loginParams).then(function (mfLoginResponse) {
                        if (angular.isDefined(mfLoginResponse.status) && mfLoginResponse.status.code == 200) {
                            if (mfLoginResponse.data.Success == true) {
                                postLogin(response);
                            }
                        }
                        else {
                            $scope.dataLoading = false;
                            ToastService.showCustomToast("error", mfLoginResponse.status.message);
                        }
                    });
                }

                function postLogin(response) {
                    if (response.data.isFirstLogin == "true") {
                        CurrentUserService.firstLoginSetup();
                    }


                    loginCtrl.CurrentUser = response.data;
                    loginCtrl.CurrentUser.FirstName = response.data.firstName;
                    loginCtrl.CurrentUser.LastName = response.data.lastName;
                    loginCtrl.CurrentUser.Name = loginCtrl.CurrentUser.FirstName + ' ' + loginCtrl.CurrentUser.LastName;
                    loginCtrl.CurrentUser.ImageUrl = response.data.imageUrl;

                    if (loginCtrl.CurrentUser.ImageUrl == undefined || loginCtrl.CurrentUser.ImageUrl == null
                        || loginCtrl.CurrentUser.ImageUrl == "") {
                        loginCtrl.CurrentUser.ImageUrl = "assets/images/profile.jpg";
                    }
                    if (!angular.equals(loginCtrl.CurrentUser, CurrentUserService.getUser())) {
                        CurrentUserService.setUser(loginCtrl.CurrentUser);
                        //before transitioning populating the response data into local storage
                        localStorage.setItem("user", JSON.stringify(response.data));
                    }
                    cacheStore.removeAll();
                    $state.transitionTo('private.dashboard').then(function () {
                        $scope.dataLoading = false;
                    }, function () {
                        $scope.dataLoading = false;
                    });



                    firebase.setTmxUserProperties({
                        UserName: loginCtrl.CurrentUser.Name,
                        UserEmail: loginCtrl.CurrentUser.userName,
                        Culture: tmxUtility.getCurrentCulture()
                    });
                    firebase.logTmxEvent('login_successful');
                    localStorage.removeItem("IsConfiguredDeviceSet");
                    localStorage.removeItem("ConfiguredDeviceName");
                }

                $scope.changeCulture = function (culture) {
                    if (culture != null) {
                        localStorage.setItem('culture', culture);
                        $translate.use(culture);
                    }
                }

                $scope.authenticate = function (provider) {
                    $scope.formDisabled = true;
                    $scope.error = "";
                    $auth.authenticate(provider)
                        .then(function (response) {
                            if (response.data != null && response.data.status != null && response.data.status.code != 200) {
                                $scope.error = response.data.status.message;
                                return;
                            }
                            $scope.formDisabled = false;
                            if (response.data.access_token == "unregistered") {
                                localStorage.removeItem("TMX_access_token");
                                RegistrationUserDataService.user = {
                                    FirstName: response.data.firstName,
                                    LastName: response.data.lastName,
                                    EmailAddress: response.data.email,
                                    ImageUrl: response.data.imageUrl,
                                    ExternalProvider: response.data.externalProvider,
                                    ExternalAccessToken: response.data.externalAccessToken,
                                    ExternalSocialId: response.data.externalSocialId,
                                    SocialData: {}
                                };
                                $state.transitionTo('public.register');
                                //  $location.path('/register');
                            }
                            else {
                                if (response.data.isFirstLogin == "true") {
                                    CurrentUserService.firstLoginSetup();
                                }
                                $state.transitionTo('private.dashboard');
                            }
                        })
                        .catch(function (response) {
                            $scope.formDisabled = false;
                            if (response.data != null && response.data.message != null)
                                $scope.error = response.data.message;
                            else
                                $scope.error = "Your " + provider + " account cannot be linked";
                        });
                };

                function confirmationDialog(message, successCb, errorCb) {
                    var confirm = $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('Confirm')
                        .textContent(message)
                        .ariaLabel(message)
                        .ok('Yes')
                        .cancel('No');
                    $mdDialog.show(confirm).then(successCb, errorCb);
                }
            }]);
})();